<template>
  <div>
    <v-btn @click="goReservation">push Route</v-btn>
  </div>
</template>

<script>
import {VueShowdown} from 'vue-showdown'
// import {mapFields} from 'vuex-map-fields'
// import LPlatePicker from '../../components/Inputs/LPlatePicker'
export default {
  name: 'testRouter1',
  components: {VueShowdown},
  data: () => ({
    markdownText: '# Hello World',
    vheaders: [
      {text: '车辆号牌', value: 'carNumber', align: 'left'},
      {text: '车主姓名', value: 'name', align: 'right'},
      {text: '违章区域', value: 'area', align: 'right'},
      {text: '违章状态', value: 'status', align: 'right'},
    ],
    plate: '',
  }),
  methods: {
    goReservation () {
      this.$L.tab.close(this.$L.tab.current, false)
      this.$router.push({name: 'NewPersonalReservation'})
    },
  },
  created () {
  },
}
</script>

<style scoped>
</style>
